import { useState } from 'react'
import { Link } from 'react-router-dom'
import { dateFormat } from '../helpers/dateFormat'
import { InfoBox } from './ui/InfoBox'
import { useOldDate } from '../hooks/useOldDate'
import Badge from './ui/Badge'
import { CoverImage } from './cards/CoverImage'
import { Report } from '../interfaces/intakes.reports'
import { LuMailCheck, LuMailX } from "react-icons/lu";

interface Props {
    setOpenConfirmation: (open: boolean) => void
    setCurrentId: (id: string) => void
    setOpenSendPDF: (open: boolean) => void
    report: Report
    unfinished?: boolean
}

export const CardReport = ({ setOpenConfirmation, setCurrentId, setOpenSendPDF, report, unfinished = false }: Props) => {

    const { scoreNumber } = useOldDate(report.date, report.score)
    const [activeDots, setActiveDots] = useState(false)

    return (
        <div className="card mb-1">

            <Link
                to={unfinished ? `/create-report/${report._id}` : `/report/${report._id}`}
                className="card__image">
                <CoverImage pallets={report.pallets} mainDataImages={report.mainDataImages || []} />
            </Link>

            <div className='tw-flex tw-flex-1'>
                <Link
                    to={unfinished ? `/create-report/${report._id}` : `/report/${report._id}`}
                    className="card__content tw-flex-1">
                    <div className="card__body">
                        <div className="card__title flex">
                            <h4>{report.mainData?.pallet_ref || "--"}</h4>
                            {unfinished && <Badge small ml color='red'>Unfinished</Badge>}

                        </div>
                        <p className="card__text">{report.mainData?.supplier || "--"}</p>
                        <p className="card__text">{report.mainData?.total_pallets || "--"}</p>
                        <p className="card__text"><small className="text-muted">{dateFormat(report.date) || "--"}</small></p>
                    </div>
                </Link>

                <div className='tw-flex tw-flex-col tw-justify-between tw-items-end tw-p-2'>
                    <button
                        className='tw-mr-[.1rem] tw-mt-[.2rem]'
                        onClick={() => {
                            setActiveDots(true)
                        }}>
                        <img src='../assets/img/dots-icon.svg' alt="dots-icon" className='tw-w-3' />
                    </button>


                    <InfoBox
                        show={activeDots}
                        onClickOutside={() => { setActiveDots(false) }}
                    >
                        {/* {
                            !unfinished &&
                            <p className='font-normal mb-05'
                                onClick={() => {
                                    setCurrentId(report._id)
                                    setOpenSendPDF(true)
                                }}
                            >Send report</p>
                        } */}
                        <p className='font-normal'
                            onClick={() => {
                                setCurrentId(report._id)
                                setOpenConfirmation(true)
                            }}
                        >Delete</p>
                    </InfoBox>

                    <div className='tw-flex tw-items-center tw-gap-3'>
                        {
                            report.mailed
                            ? <LuMailCheck size={15} strokeWidth={2.5} className='tw-text-green-600' />
                            : <LuMailX size={15} strokeWidth={2.5} className='tw-text-neutral-200' />
                        }
                        <span
                            className={`tw-mr-1 tw-mt-[.1rem] tw-rounded-full tw-w-2 tw-h-2 circle-score${scoreNumber}`}
                        ></span>
                    </div>

                </div>
            </div>


            {/* <button
                className="remove"
                onClick={() => {
                    setActiveDots(true)
                }}>
                <img src='../assets/img/dots-icon.svg' alt="dots-icon" />
            </button>


            <InfoBox
                show={activeDots}
                onClickOutside={() => { setActiveDots(false) }}
            >
                {
                    !unfinished &&
                    <p className='font-normal mb-05'
                        onClick={() => {
                            setCurrentId(report._id)
                            setOpenSendPDF(true)
                        }}
                    >Send report</p>
                }
                <p className='font-normal'
                    onClick={() => {
                        setCurrentId(report._id)
                        setOpenConfirmation(true)
                    }}
                >Delete</p>
            </InfoBox>

            <span
                className={`circle-score circle-score${scoreNumber}`}
            ></span> */}

        </div>
    )
}
